import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getCartInfo } from "../reducer/userCartSlice";
import ShareModal from "../components/modal/ShareModal";
import SizeChartModal from "../components/modal/SizeChartModal";
import AddToCartModal from "../components/modal/AddToCartModal";
import ProceedToBuyModal from "../components/modal/ProceedToBuyModal";
import ApplyCouponModal from "../components/modal/ApplyCouponModal";
import AddressModal from "../components/modal/AddressModal";
import { apiBaseUrl } from "../config";
import { getDomainInfo } from "../utils/utils";
import { useUser } from "../context/userContext";

export default function CommonLayout({ children }) {
  const userid = useSelector((state) => state.fetchUser?.user?.id);
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const customerId = localStorage.getItem("customerId");
  const cartContext = localStorage.getItem("cartContext");
  const { userId } = useParams();
  const { uid } = getDomainInfo(userId);
  const { userData, fetchUserData } = useUser();

  useEffect(() => {
    if (uid) {
      fetchUserData(uid);
    } else {
      console.error("UID is undefined, skipping fetchUserData.");
    }
  }, [uid]);

  // Function to fetch user cart info
  const fetchUserCartInfo = async (storeId, token) => {
    if (!storeId || !customerId) {
      console.warn("Missing necessary data for cart request.");
      return;
    }
    try {
      const response = await fetch(`${apiBaseUrl}cart/fetch-user-cart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { token: token }),
        },
        body: JSON.stringify({
          storeid: storeId,
          customerId: customerId,
          cartContext: cartContext,
        }),
      });
      const data = await response.json();
      if (data?.cart) {
        dispatch(getCartInfo(data.cart));
      }
    } catch (e) {
      console.error("Error while fetching user cart information:", e);
    }
  };

  // Initialization logic
  const init = async () => {
    const token = localStorage.getItem("token");
    if (userData?.id) {
      await fetchUserCartInfo(userData.id, token);
    }
  };

  useEffect(() => {
    if (userData?.id && !hasFetched.current) {
      hasFetched.current = true;
      init();
    }
  }, [userData?.id]);

  return (
    <>
      {children}
      {/* Modals */}
      <ShareModal />
      <SizeChartModal />
      {/* <AddToCartModal /> */}
      <ProceedToBuyModal />
      <ApplyCouponModal />
      <AddressModal />
    </>
  );
}
